import { Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import { NavLink, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Helmet } from "react-helmet";
import { toPascalCase } from "utils/string-utils";
import { useEffect, useState } from "react";

//#region Interfaces ... 
interface ILinkTabProps {
    text?: string;
    href?: string;
    selected?: boolean;
}
//#endregion

//#region Styles Components ... 
const TaskTabs = styled(Tabs)({
    color: '#333333',
    '& .MuiTabs-indicator': {
        color: '#001A69',
        backgroundColor: '#001A69',
        height: '3px',
        borderRadius: '4px',
    }
});

const TabLinkStyled = styled(NavLink)(({ theme }) => ({
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: '10px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '22px',
    color: '#333333',
    textTransform: 'uppercase',
    textDecoration: 'none',

    '&.active': {
        color: theme.palette.secondary.main,
        fontWeight: 600
    }
}));
//#endregion 

const TabLink = (props: ILinkTabProps) => (
    <TabLinkStyled 
        to={props.href || ""}
    >
        {props.text}
    </TabLinkStyled>
)

const LinkTab = (props: ILinkTabProps) => (
    <Tab
        component={TabLink}
        {...props}
    />
)

const tabs = [
    {
        text: 'OVERVIEW',
        path: '/overview'
    },
    {
        text: 'MY TASKS',
        path: '/my/tasks'
    },
    {
        text: 'WORK ITEMS AND WORKFLOWS',
        path: '/workitems-workflow'
    },
    {
        text: 'PROJECT MILESTONES',
        path: '/milestones'
    }
];

const ProjectsTabsHeader = ({ ...props }) => {
    const currentURL: string = window.location.href;
    const suffix: string = currentURL.includes('all') ? 'all' : 'my';
    const [ selectedTabName, setSelectedTabName ] = useState('');
    const location = useLocation();
    let selectedTab = -1;

    useEffect(() => {
        for (let i = tabs.length - 1; i >= 0; i--) {
            if (location.pathname.includes(tabs[i].path)) {
                setSelectedTabName(tabs[i].text.toLowerCase().replace(' ', '-'));
                break;
            }
        }
    }, [location.pathname]);
    
    for (var i = tabs.length -1; i >= 0; i--) {
        if (location.pathname.includes(tabs[i].path)) {
            selectedTab = i;
            break;
        }
    }

    return (
        <Box sx={{ width: '100%', mb: '25px', paddingTop: '20px' }}>
            <Helmet>
                <title>Sage Central | Project | {toPascalCase(selectedTabName)}</title>
            </Helmet>
            <TaskTabs value={selectedTab} aria-label="tasks tabs">
            {
                tabs.map((tab, index) => (<LinkTab selected={true} text={tab.text} href={`/${props.type ? props.type: 'projects/'+suffix+'/'}${props.ProjectId + tab.path}`} />))
            }
            </TaskTabs>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: '-2px' }}></Box>
        </Box>
    )
}

export default ProjectsTabsHeader;